module.exports = __webpack_public_path__ + "static/img/label-02.041cf95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/flash/label-02.png
// module id = f4Hn
// module chunks = 150